import { render, staticRenderFns } from "./CuitField.vue?vue&type=template&id=327c9816&scoped=true"
import script from "./CuitField.vue?vue&type=script&lang=js"
export * from "./CuitField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327c9816",
  null
  
)

export default component.exports